import React from "react";

const TrialSum = ({ row }) => {
  return (
    <div>
      {row.details.length !== 0 ? (
        <div
          style={{
            borderBottom: "dashed 1px gray",
            marginBottom: "5px",
          }}
        >
          {row.details.map((service, index) => (
            <div key={index} style={{ paddingBottom: "5px" }}>
              {service?.costTrialSum?.toLocaleString()}
            </div>
          ))}
        </div>
      ) : null}
      <div>{row.costTrialSum?.toLocaleString()}</div>
    </div>
  );
};

export default TrialSum;
